import { render, staticRenderFns } from "./diverseSlider_new.vue?vue&type=template&id=3890ef44&scoped=true"
import script from "./diverseSlider_new.vue?vue&type=script&lang=js"
export * from "./diverseSlider_new.vue?vue&type=script&lang=js"
import style0 from "./diverseSlider_new.vue?vue&type=style&index=0&id=3890ef44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3890ef44",
  null
  
)

export default component.exports